import {Splide} from '@splidejs/splide';
import {Intersection} from '@splidejs/splide-extension-intersection';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

const sitewideCarousel = () => {
    const $ = jQuery;

    const wrappers = $('.sitewide-carousel .sitewide-carousel-wrapper');

    if (wrappers.length === 0) {
        return true;
    }

    wrappers.each((i, wrapper) => {
        const sitewideCarousel = new Splide(wrapper, {
            type: 'carousel',
            loop: false,
            perPage: 3,
            gap: '1rem',
            padding: {
                right: '15%'
            },
            arrows: true,
            pagination: false,
            breakpoints: {
                1440: {
                    perPage: 3,
                    padding: {
                        right: '10%'
                    }
                },
                1366: {
                    perPage: 2,
                    padding: {
                        right: '25%'
                    }
                },
                769: {
                    perPage: 1,
                    padding: {
                        right: '35%'
                    }
                }
            }
        });
        const progressBar = sitewideCarousel.root.querySelector('.carousel__progress_bar');

        // Updates the bar width whenever the carousel moves:
        sitewideCarousel.on('mounted move', () => {
            if (!progressBar) return;

            const end = sitewideCarousel.Components.Controller.getEnd() + 1;
            const rate = Math.min((sitewideCarousel.index + 1) / end, 1);

            progressBar.style.width = String(100 * rate) + '%';

            // CSS transition helper, toggle "progress-full" class to the bar to indicate when the carousel is at its end
            if (rate === 1) {
                setTimeout(() => progressBar.classList.add('carousel__progress_bar--progress-full'), 300);
            } else {
                setTimeout(() => progressBar.classList.remove('carousel__progress_bar--progress-full'), 300);
            }


        });

        sitewideCarousel.mount();
    });
};

export default sitewideCarousel;